export default "__VITE_ASSET__BOVTz7Cc__"